import { bookLoaded } from "../features/Books/actions";

const fetchBooks = async (dispatch, getState) => {
 let response = await fetch("http://localhost:9000/books");
 let books = await response.json();
 dispatch(bookLoaded(books));
};

export default fetchBooks;
